import React, { Component } from "react";
import { showErrorNotification, strings } from "../../helpers";
import { getStats } from "../../services";
import NewsStatsView from "./NewsStatsView";
import TopSpecialitiesView from "./TopSpecialitiesView";
import TopCitiesView from "./TopCitiesView";
import TopStatesView from "./TopStatesView";

export default class WeeklyStatusContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newsTypes: [],
      isProcessing: false,
      states: [],
      cities: [],
      isProcessing: false,
      specialities: []
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  /**
   * @function fetchDoctorsList
   * @description This function get doctors data
   */
  fetchStats = () => {
    this.setState({
      isProcessing: true
    });
    getStats()
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response && response.data && response.data.success) {
          const {
            news_types,
            top_states,
            top_cities,
            top_specialities
          } = response.data.data;
          this.setState({
            newsTypes: news_types,
            states: top_states,
            cities: top_cities,
            specialities: top_specialities
          });
        } else {
          this.setState({
            newsTypes: [],
            states: [],
            cities: [],
            specialities: []
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({
          newsTypes: [],
          states: [],
          cities: [],
          specialities: [],
          isProcessing: false
        });
      });
  };

  render() {
    const {
      newsTypes,
      states,
      cities,
      isProcessing,
      specialities
    } = this.state;
    return (
      <>
        <TopSpecialitiesView
          specialities={specialities}
          isProcessing={isProcessing}
        />
        <TopCitiesView cities={cities} isProcessing={isProcessing} />
        <TopStatesView states={states} isProcessing={isProcessing} />
        <NewsStatsView newsTypes={newsTypes} isProcessing={isProcessing} />
      </>
    );
  }
}
